<div class="row">
  <div *ngIf="tArea" class="col s6">
    <h4 class="card-title" style="margin-bottom:0; line-height:1;"><i (click)="areaViewRoot(tArea)" *ngIf="!isRoot" class="material-icons tatt-i-btn">chevron_left</i> {{tArea.areaName}}</h4>
    <p>
      <!-- {{pageData.zones.length}} zone(s) in total. -->
      {{tArea.remark}}
    </p>
  </div>
  <div *ngIf="pageData.viewMode=='LIST'" class="col s6 right-align">
    <a (click)="areaForm()" class="waves-effect waves-light btn gradient-45deg-red-pink tatt-btn" style="margin-right: 1px;">
      <i class="material-icons left">add</i>Area
    </a>
  </div>
</div>
<div *ngIf="pageData.viewMode=='LIST'">
<div class="row" *ngIf="tArea">
   <div class="col s12 m6 img__wrap">
      <div class="row">
         <img [src]="imgPath" class="responsive-img" />
      <!-- <img src="./assets/img/floorplans/{{client + '-' + tArea.areaName}}.png" class="responsive-img" /> -->
      <!-- <img [src]="tArea.imgB64" class="responsive-img" (click)="file.click()" style="cursor: pointer;" /> not use -->
      <input type="file" id="file" #file style="display: none;" (change)="onFileChange($event)" accept="image/*"/>
         <a class="waves-effect waves-light btn button cyan tatt-btn mt-2 ml-2 mr-2 right hide"><i class="material-icons right">cloud_download</i>Download</a>
      </div>
      <div class="col s12 m12 row">
      <i class="material-icons prefix">folder</i>
      <input #myInput class="form-control" (change)="photoSelectFile($event)" id="file" type="file" accept="image/*"/>
      <a *ngIf="isUpload" (click)="fpImgUpload(tArea)" class="waves-effect waves-light btn tatt-btn mt-2 ml-2 mr-2">Upload</a>
      </div>
   </div>
   <!-- <div class="input-field col s12"> -->
      
   <!-- </div> -->
   <div class="col s12 m6">
      <div class="row">
         <div class="col s12 m4">
            <div>
               <label>
                  <input (change)="areaConfigChange('area.occupancy')" type="checkbox" [(ngModel)]="tArea.isOccupancyArea" />
                  <span>Occupancy Area</span>
               </label>
            </div>
            <div>
               <label>
                  <input (change)="areaConfigChange('area.standalone')" type="checkbox" [(ngModel)]="tArea.isStandaloneArea" />
                  <span>Standalone Area</span>
               </label>
            </div>
            <div>
               <label>
                  <input (change)="areaConfigChange('area.enable.dwelltime')" type="checkbox" [(ngModel)]="tArea.isDwellTimeEnabled" />
                  <span>Enable Dwell Time</span>
               </label>
            </div>
            <!-- <div>
               <label>
                  <input (change)="areaConfigChange('area.priority')" type="checkbox" [(ngModel)]="tArea.isPriority" />
                  <span>Enable Priority</span>
               </label>
            </div> -->
            <div>&nbsp;</div>
            <div class="row">
               <div class="col s12 row">
                  <ul id='ddl_dashboard_areas' class='dropdown-content'>
                     <li>
                       <a href="javascript:void(0);" class="li_area">1</a>
                     </li>
                   </ul>                   
               <div class="input-field s12">                  
                  <select (change)="prioritySelectDdl($event.target.value)">
                     <option [selected]="tArea.isPriority==1" value="1">1 (Lowest)</option>
                     <option [selected]="tArea.isPriority==2" value="2">2</option>
                     <option [selected]="tArea.isPriority==3" value="3">3</option>
                     <option [selected]="tArea.isPriority==4" value="4">4</option>
                     <option [selected]="tArea.isPriority==5" value="5">5</option>
                     <option [selected]="tArea.isPriority==6" value="6">6</option>
                     <option [selected]="tArea.isPriority==7" value="7">7</option>
                     <option [selected]="tArea.isPriority==8" value="8">8</option>
                     <option [selected]="tArea.isPriority==9" value="9">9</option>
                     <option [selected]="tArea.isPriority==10" value="10">10</option>
                     <option [selected]="tArea.isPriority==11" value="11">11</option>
                     <option [selected]="tArea.isPriority==12" value="12">12</option>
                     <option [selected]="tArea.isPriority==13" value="13">13</option>
                     <option [selected]="tArea.isPriority==14" value="14">14</option>
                     <option [selected]="tArea.isPriority==15" value="15">15</option>
                     <option [selected]="tArea.isPriority==16" value="16">16</option>
                     <option [selected]="tArea.isPriority==17" value="17">17</option>
                     <option [selected]="tArea.isPriority==18" value="18">18</option>
                     <option [selected]="tArea.isPriority==19" value="19">19</option>
                     <option [selected]="tArea.isPriority==20" value="20">20 (Highest)</option>
                  </select>
                  <label>Priority</label>
               </div>               
               </div>
             </div>
         </div>
         <div class="col s12 m8 right-align">
            <a (click)="sensorForm()" class="waves-effect waves-light btn gradient-45deg-red-pink tatt-btn">
               <i class="material-icons left">add</i>Sensor
            </a>
         </div>
         <div class="col s12 m8 right-align"></div>
         <div class="col s12 m8 right-align"></div>
         <div class="col s12 m8 right-align"></div>
         <div class="col s12 m8 right-align"></div>
         <!-- <div class="col s12 m8 right-align">
            <a (click)="locationSetUpForm()" class="waves-effect waves-light btn gradient-45deg-red-pink tatt-btn">
               <i class="material-icons left">add</i>Location Setup
            </a>
         </div> -->
      </div>
      <div>
         <hr style="opacity:0.3"/>
      </div>
      <div class="row">
         <div class="col s12 m12">
            <div>
               <div *ngFor="let rec of tArea.sensors">
                  <i class="material-icons hide" style="margin-right:5px; font-size:30px; opacity: 0.7;">visibility</i>
                  <div *ngIf="rec.inFlow==1" class="s-c-in">&nbsp;</div>
                  <div *ngIf="rec.inFlow==2" class="s-c-out">&nbsp;</div>
                  <div *ngIf="rec.inFlow==0" class="s-c-na">&nbsp;</div>
                  <div *ngIf="rec.outFlow==1" class="s-c-in">&nbsp;</div>
                  <div *ngIf="rec.outFlow==2" class="s-c-out">&nbsp;</div>
                  <div *ngIf="rec.outFlow==0" class="s-c-na">&nbsp;</div>
                  <a (click)="sensorEdit(rec)" href="javascript:void(0);" style="margin-left: 5px;">{{rec.sensorName}}</a> 
                  <span style="font-size: smaller; opacity:0.7;">- {{rec.sensorId}}</span>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="row" *ngIf="imgUpload">
   <!-- <div class="progress form-group" *ngIf="progress > 0">
      <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress">
      </div>
  </div> -->
  <!-- <div
    class="progress-bar progress-bar-info progress-bar-striped"
    role="progressbar"
    attr.aria-valuenow="{{ progress }}"
    aria-valuemin="0"
    aria-valuemax="100"
    [ngStyle]="{ width: progress + '%' }"
  >
    {{ progress }}%
  </div> -->
   <div class="col s3"><img [src]="ImageBaseData" width="400px" height="200px"/></div>
   <div class="col s4 center mt-5">
      <a (click)="imgUpdate(tArea)" class="waves-effect waves-light btn tatt-btn mt-2 ml-2 mr-2">Upload</a>
      <a (click)="imgCancel($event)" class="waves-effect waves-light btn #ef5350 white lighten-3 tatt-btn mt-2 ml-2" style="color:black">Cancel</a>
   </div>
   <div class="col s5"></div>
</div>
<div class="row" *ngIf="tArea">
   <div *ngFor="let rec of tArea.childAreas" class="col s12 m6">
      <div class="card gradient-45deg-light-blue-cyan">
         <div class="card-content white-text">
            <div class="center">
               <h6 class="card-title font-weight-400 white-text">{{rec.areaName}}</h6>
               
               <!-- <img src="./assets/img/floorplans/{{client + '-' + rec.areaName}}.png?v=20230827" alt="" class="responsive-img" style="opacity:1;"> -->
               <img [src]="rec.imgB64" alt="" class="responsive-img" style="opacity:1;">
               <p></p>
            </div>
            <div class="">
               <div class="right">{{rec.remark}}</div>
               <div>{{rec.childAreas ? rec.childAreas.length + ')' : '-'}} Sub-Areas</div>
               <div>{{rec.sensors ? rec.sensors.length + ')' : '-'}}  Devices</div>
            </div>
         </div>
         <div class="card-action border-non center">
            <a (click)="areaView(rec)" class="waves-effect waves-light btn gradient-45deg-red-pink box-shadow">VIEW</a>
         </div>
      </div>
   </div>
</div>
<div class="carousel" style="height:300px;">
  <a *ngFor="let rec of pageData.zones" (click)="zoneSelect(rec)" class="carousel-item" href="javascript:void(0);">
    <img src="{{rec.floorplanUrl}}" style="border:1px solid #d3d3d3;">
  </a>
</div>
<div class="row" *ngIf="zoneSelected">
  <div class="row">
    <div class="col s12 m12">
      <div class="card gradient-45deg-light-blue-cyan gradient-shadow">
        <div class="card-content white-text">
          <div class="row">
            <div class="col s6">
              <span class="card-title" style="margin-bottom:0;">{{zoneSelected.title}}</span>
              <p style="opacity:0.7;">{{zoneSelected.desc}}</p>
            </div>
            <div class="col s6 right-align">
              <a class="waves-effect waves-light btn gradient-45deg-red-pink">
                <i class="material-icons left">add</i>SubZone
              </a>
            </div>
          </div>
          <div class="row" style="color:#6b6f82;">
            <div class="col s12 m12 xl6 hide">
               <ul id="projects-collection" class="collection z-depth-1">
                  <li class="collection-item avatar">
                     <i class="material-icons cyan circle">card_travel</i>
                     <h6 class="collection-header m-0">Projects</h6>
                     <p>Your Favorites</p>
                  </li>
                  <li class="collection-item">
                     <div class="row">
                        <div class="col s6">
                           <p class="collections-title font-weight-600">Web App</p>
                           <p class="collections-content">AEC Company</p>
                        </div>
                        <div class="col s3"><span class="task-cat cyan">Development</span></div>
                        <div class="col s3">
                           <div id="project-line-1"><canvas width="104" height="30" style="display: inline-block; width: 104.512px; height: 30px; vertical-align: top;"></canvas></div>
                        </div>
                     </div>
                  </li>
                  <li class="collection-item">
                     <div class="row">
                        <div class="col s6">
                           <p class="collections-title font-weight-600">Mobile App for Social</p>
                           <p class="collections-content">iSocial App</p>
                        </div>
                        <div class="col s3"><span class="task-cat red accent-2">UI/UX</span></div>
                        <div class="col s3">
                           <div id="project-line-2"><canvas width="104" height="30" style="display: inline-block; width: 104.512px; height: 30px; vertical-align: top;"></canvas></div>
                        </div>
                     </div>
                  </li>
                  <li class="collection-item">
                     <div class="row">
                        <div class="col s6">
                           <p class="collections-title font-weight-600">Website</p>
                           <p class="collections-content">MediTab</p>
                        </div>
                        <div class="col s3"><span class="task-cat teal accent-4">Marketing</span></div>
                        <div class="col s3">
                           <div id="project-line-3"><canvas width="104" height="30" style="display: inline-block; width: 104.512px; height: 30px; vertical-align: top;"></canvas></div>
                        </div>
                     </div>
                  </li>
                  <li class="collection-item">
                     <div class="row">
                        <div class="col s6">
                           <p class="collections-title font-weight-600">AdWord campaign</p>
                           <p class="collections-content">True Line</p>
                        </div>
                        <div class="col s3"><span class="task-cat deep-orange accent-2">SEO</span></div>
                        <div class="col s3">
                           <div id="project-line-4"><canvas width="104" height="30" style="display: inline-block; width: 104.512px; height: 30px; vertical-align: top;"></canvas></div>
                        </div>
                     </div>
                  </li>
               </ul>
            </div>
            <div class="col s12 m12 xl6" *ngFor="let sz of zoneSelected.subzones">
               <ul id="issues-collection" class="collection z-depth-1">
                  <li class="collection-item avatar">
                    <div class="row">
                      <div class="col s8">
                        <i class="material-icons cyan circle">view_quilt</i>
                        <h6 class="collection-header m-0">{{sz.title}}</h6>
                        <p>{{sz.desc}}</p>
                      </div>
                      <div class="col s4 right-align">
                        <a class="btn-floating mb-1 btn waves-effect waves-light gradient-45deg-red-pink">
                          <i class="material-icons">add</i>
                        </a>
                      </div>
                    </div>
                  </li>
                  <li class="collection-item" *ngFor="let dvc of sz.devices">
                     <div class="row">
                        <div class="col s7">
                           <p class="collections-title font-weight-600">{{dvc.name}}</p>
                           <p class="collections-content">{{dvc.id}}</p>
                        </div>
                        <div class="col s2"><span class="task-cat deep-orange accent-2">{{dvc.code}}</span></div>
                        <div class="col s3">
                           <div class="progress">
                              <div class="determinate" style="width: 70%"></div>
                           </div>
                        </div>
                     </div>
                  </li>
                  <li class="collection-item hide">
                     <div class="row">
                        <div class="col s7">
                           <p class="collections-title font-weight-600"><strong>#108</strong> API Fix</p>
                           <p class="collections-content">API Project</p>
                        </div>
                        <div class="col s2"><span class="task-cat cyan">P2</span></div>
                        <div class="col s3">
                           <div class="progress">
                              <div class="determinate" style="width: 40%"></div>
                           </div>
                        </div>
                     </div>
                  </li>
               </ul>
            </div>
         </div>
        </div>
        <div class="card-action">
          
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div *ngIf="pageData.viewMode == 'SENSOR-FORM'" style="margin-top: 15px;">
   <div class="row">
      <div class="input-field col s12">
         <i class="material-icons prefix">visibility</i>
         <input [(ngModel)]="pageData.sensorId" id="txtSensorId" name="txtSensorId" type="text" />
         <label for="txtSensorId" class="active">Sensor ID</label>
      </div>
      <div class="input-field col s12">
         <i class="material-icons prefix">visibility</i>
         <input [(ngModel)]="pageData.sensorName" id="txtSensorName" name="txtSensorName" type="text" />
         <label for="txtSensorName" class="active">Sensor Name</label>
      </div>
      <div class="col s12 m6" style="padding-left: 60px;">
         <span style="text-transform: uppercase; font-weight: bold;">In Flow</span>
         <p>
            <label>
              <input name="group1" type="radio" [value]="1" [(ngModel)]="pageData.sensorInFlow" />
              <span>ENTRY</span>
            </label>
          </p>
          <p>
            <label>
              <input name="group1" type="radio" [value]="2" [(ngModel)]="pageData.sensorInFlow" />
              <span>EXIT</span>
            </label>
          </p>
          <p>
            <label>
              <input class="with-gap" name="group1" type="radio" [value]="0" [(ngModel)]="pageData.sensorInFlow" />
              <span>NA</span>
            </label>
          </p>
          <div class="input-field col s12">
             <input [(ngModel)]="pageData.inTune" id="txtSensorInTune" name="txtSensorInTune" type="text" />
             <label for="txtSensorInTune" class="active">In Tune</label>
          </div>
      </div>
      <div class="col s12 m6" style="padding-left: 60px;">
         <span style="text-transform: uppercase; font-weight: bold;">Out Flow</span>
         <p>
            <label>
              <input name="group2" type="radio" [value]="1" [(ngModel)]="pageData.sensorOutFlow" />
              <span>ENTRY</span>
            </label>
          </p>
          <p>
            <label>
              <input name="group2" type="radio" [value]="2" [(ngModel)]="pageData.sensorOutFlow" />
              <span>EXIT</span>
            </label>
          </p>
          <p>
            <label>
              <input class="with-gap" name="group2" type="radio" [value]="0" [(ngModel)]="pageData.sensorOutFlow" />
              <span>NA</span>
            </label>
          </p>
          <div class="input-field col s12">
             <input [(ngModel)]="pageData.outTune" id="txtSensorOutTune" name="txtSensorOutTune" type="text" />
             <label for="txtSensorOutTune" class="active">Out Tune</label>
          </div>
      </div>
   </div>
   <div class="row">
     <div class="input-field col s12">
       <button (click)="sensorFormSave()" class="btn cyan waves-effect waves-light right" type="submit" name="action">Submit
         <i class="material-icons right">send</i>
       </button>
       <button (click)="sensorFormCancel()" class="btn cyan lighten-2 waves-effect waves-light right" type="button" name="action" style="margin-right: 2px;">Cancel
       </button>
       <button (click)="sensorRemove()" class="btn red waves-effect waves-light" type="button" name="action">Delete
         <i class="material-icons left">delete</i>
       </button>
     </div>
   </div>
</div>
<div *ngIf="pageData.viewMode == 'AREA-FORM'" style="margin-top: 15px;">
   <div class="row">
      <div class="input-field col s12">
         <i class="material-icons prefix">branding_watermark</i>
         <input [(ngModel)]="pageData.areaName" id="txtAreaName" name="txtAreaName" type="text" />
         <label for="txtAreaName" class="active">Area Name</label>
      </div>
      <div class="input-field col s12">
         <i class="material-icons prefix">branding_watermark</i>
         <input [(ngModel)]="pageData.areaRemark" id="areaRemark" name="areaRemark" type="text" />
         <label for="areaRemark" class="active">Area Remark</label>
      </div>
      <div class="input-field col s12">
         <i class="material-icons prefix">folder</i>
         <input class="form-control" (change)="onFileChange($event)" id="file" type="file" accept="image/*"/>
      </div>
      <div class="input-field col s12" *ngIf="imgUpload"><img [src]="ImageBaseData" width="400px" height="200px"/></div>
      
   </div>
   <div class="row">
     <div class="input-field col s12">
       <button (click)="areaFormSave()" class="btn cyan waves-effect waves-light right" type="submit" name="action">Submit
         <i class="material-icons right">send</i>
       </button>
       <button (click)="areaFormCancel()" class="btn cyan lighten-2 waves-effect waves-light right" type="submit" name="action" style="margin-right: 2px;">Cancel
       </button>
     </div>
   </div>
</div>